function intercom(...a: any[]) {
    window.Intercom && window.Intercom(...a);
}

function boot(userData = {}) {
    const id = options.isProduction ? '93c0bf3bdc0786f3e0f9eae1ce240e8bc01833da' : 'nmrm9rdp';

    intercom('boot', {
        app_id: id,
        user_data: userData
    });
}

function setUser(user: anm.User) {
    const {username, email, userId, avatar} = user;

    boot({
        email,
        avatar,
        user_id: userId,
        name: username
    });
}

function setAnonymous() {
    intercom('shutdown');
    boot();
}

function show() {
    intercom('show')
}

function hide() {
    intercom('hide')
}

function unreadCountChange(cb: (n: number) => void) {
    intercom('onUnreadCountChange', cb);
}

export default {
    boot,
    setUser,
    setAnonymous,
    show,
    hide,
    unreadCountChange
}


// WEBPACK FOOTER //
// ./app/assets/javascripts/intercom.ts